// src/routes/componentRegistry.js
import React from "react";

// عامة
const LoginPage = React.lazy(() => import("../pages/auth/LoginPage"));
const ForgotPassword = React.lazy(() => import("../pages/auth/ForgotPassword"));
const ResetPassword = React.lazy(() => import("../pages/auth/ResetPassword"));
const ProductNames = React.lazy(() => import("../pages/ProductNames"));
const RawMaterialNames = React.lazy(() => import("../pages/RawMaterialNames"));
const ReadyMaterialNames = React.lazy(() => import("../pages/ReadyMaterialNames"));
const Users = React.lazy(() => import("../pages/Users"));

// رئيسية
const PackagingMaterials = React.lazy(() =>
  import("../pages/depo/PackagingMaterials")
);
const RawMaterials = React.lazy(() => import("../pages/depo/RawMaterials"));
const ReadyMaterials = React.lazy(() => import("../pages/depo/ReadyMaterials"));

const Orders = React.lazy(() => import("../pages/Orders"));
const DepoTransactions = React.lazy(() => import("../pages/DepoTransactions"));
// 404
const NotFound = React.lazy(() => import("../pages/NotFound"));

export const componentMap = {
  // auth
  LoginPage,
  ForgotPassword,
  ResetPassword,
  Users,
  // depo
  PackagingMaterials,
  RawMaterials,
  ReadyMaterials,
  ProductNames,
  RawMaterialNames,
  ReadyMaterialNames,
  // business
  Orders,
  DepoTransactions,
  // error
  NotFound,
};
